






















import Vue from 'vue';
import { IVideo } from '@/common/interfaces/products.interface';

interface IVideoSectionComponent {
  $refs?: {
    video: HTMLVideoElement;
  };
  videoPlaying: boolean;
}

export default Vue.extend({
  name: `VideoSection`,
  data(): IVideoSectionComponent {
    return {
      videoPlaying: false,
    };
  },
  props: {
    videoData: {
      required: true,
      type: Object as () => IVideo,
    },
  },
  methods: {
    startOrStopVideo(): void {
      if(!this.videoPlaying) {
        this.$refs.video.play();
      } else {
        this.$refs.video.pause();
      }
      this.videoPlaying = !this.videoPlaying;
    },
  },
});
